import { useMemo } from "react";
import {
	useDigitzsMerchantId,
	useFromPartnerLink,
} from "stores/LocalStorageHelper";

/**
 * Hook to determine which payment processor the current merchant uses.
 *
 * Priority:
 * 1. XplorPay (new merchants) - takes precedence if configured
 * 2. Digitzs (existing merchants) - fallback
 * 3. None configured
 *
 * @returns {Object} Processor information
 */
export const usePaymentProcessor = () => {
	const digitzsMerchantId = useDigitzsMerchantId();
	const xplorpayMerchantId = useFromPartnerLink("xplorPayMerchantId");
	const xplorpayPublicKey = useFromPartnerLink("xplorPayPublicKey");
	console.log(xplorpayMerchantId, xplorpayPublicKey);
	const processorInfo = useMemo(() => {
		// Check XplorPay first (new preferred processor)
		// Explicitly check for non-null, non-empty, non-"null" string values
		const hasXplorPay = Boolean(
			xplorpayMerchantId &&
				xplorpayMerchantId !== "" &&
				xplorpayMerchantId !== "null" &&
				xplorpayPublicKey &&
				xplorpayPublicKey !== "" &&
				xplorpayPublicKey !== "null"
		);
		const hasDigitzs = Boolean(
			digitzsMerchantId &&
				digitzsMerchantId !== null &&
				digitzsMerchantId !== "" &&
				digitzsMerchantId !== "null"
		);

		if (hasXplorPay) {
			return {
				processor: "xplorpay",
				isDigitzs: false,
				isXplorPay: true,
				hasProcessor: true,
				merchantId: xplorpayMerchantId,
				publicKey: xplorpayPublicKey,
			};
		}

		if (hasDigitzs) {
			return {
				processor: "digitzs",
				isDigitzs: true,
				isXplorPay: false,
				hasProcessor: true,
				merchantId: digitzsMerchantId,
				publicKey: null,
			};
		}

		// No processor configured
		return {
			processor: null,
			isDigitzs: false,
			isXplorPay: false,
			hasProcessor: false,
			merchantId: null,
			publicKey: null,
		};
	}, [digitzsMerchantId, xplorpayMerchantId, xplorpayPublicKey]);

	return processorInfo;
};

export default usePaymentProcessor;
